const configuredBackend = (process.env.REACT_APP_BACKEND_URL || '').trim();

export const BACKEND_URL = configuredBackend.replace(/\/+$/, '');
export const API_BASE_URL = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

export function apiUrl(path = '') {
  const normalizedPath = path ? `/${String(path).replace(/^\/+/, '')}` : '';
  return `${API_BASE_URL}${normalizedPath}`;
}

export function websocketUrl(path) {
  const browserOrigin = typeof window !== 'undefined' ? window.location.origin : '';
  const base = BACKEND_URL || browserOrigin;
  if (!base) return null;

  const url = new URL(path, `${base}/`);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return url.toString();
}
